import Swiper from 'swiper/bundle';

function upsellSwiper() {
  return new Swiper('.upsell-content', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-custom",
      prevEl: ".swiper-button-prev-custom",
    },
  });
}

function upsellSwiperOptimized() {
  return new Swiper('.upsell-content-optimized', {
    slidesPerView: 'auto',
    spaceBetween: 20,
    mousewheel: {
      forceToAxis: true,
    },
    navigation: {
      nextEl: ".swiper-button-next-optimized",
      prevEl: ".swiper-button-prev-optimized",
    },
  });
}

// ---- Bloque control (checkboxes + jQuery) ----
function atcProductUpsell() {
  $("input.variant-color-input[type=\"checkbox\"]").on('click', function () {
    var $variant = $(this);
    if ($variant.is(":checked")) {
      var group = "input.variant-color-input[name='" + $variant.attr("name") + "']";
      $(group).prop("checked", false);
      $variant.prop("checked", true);
    } else {
      $variant.prop("checked", true);
    }

    // Send variant id of selected color
    $("#atc-" + $variant.attr("name")).prop("href", "/cart/add?id=" + $variant.attr("value") + "&quantity=1");

    // Show selected variant
    var imgGroup = "img.img-" + $variant.attr("name");
    $(imgGroup).prop("style", "display: none");
    $("#img-" + $variant.attr("id")).prop("style", "display: block");

    // Disable atc for sold out variants
    if ($variant.attr("available") === "true") {
      $("#atc-div-" + $variant.attr("name")).addClass("atc-upsell-product-container__available").removeClass("atc-upsell-product-container__unavailable");
    } else {
      $("#atc-div-" + $variant.attr("name")).addClass("atc-upsell-product-container__unavailable").removeClass("atc-upsell-product-container__available");
    }
  });
}

function setAtcState(atcDiv, isAvailable) {
  if (!atcDiv) return;
  atcDiv.classList.toggle('atc-upsell-product-container__available', isAvailable);
  atcDiv.classList.toggle('atc-upsell-product-container__unavailable', !isAvailable);
}

function setAtcHref(atcLink, variantId) {
  if (!atcLink) return;
  const href = variantId ? `/cart/add?id=${variantId}&quantity=1` : '';
  atcLink.setAttribute('href', href);
}

function handleColorChangeOptimized(radio) {
  if (!radio.checked) return;
  const slide = radio.closest('.swiper-slide[data-product-id]');
  if (!slide) return;

  const colorHandle = radio.dataset.color;
  const sizeSelect = slide.querySelector('.variant-size-select');
  const atcLink = slide.querySelector('.atc-upsell-product-a');
  const atcDiv = atcLink && atcLink.firstElementChild;

  slide.querySelectorAll('.product-image a[data-color]').forEach((a) => {
    a.hidden = a.dataset.color !== colorHandle;
  });

  if (sizeSelect) {
    Array.from(sizeSelect.options).forEach((opt) => {
      if (!opt.value) return;
      const matchesColor = opt.dataset.color === colorHandle;
      opt.hidden = !matchesColor;
      opt.disabled = !matchesColor || opt.dataset.available === 'false';
    });

    const firstAvailableOption = Array.from(sizeSelect.options).find(
      (opt) => opt.value && opt.dataset.color === colorHandle && !opt.disabled
    );

    if (firstAvailableOption) {
      sizeSelect.value = firstAvailableOption.value;
      setAtcHref(atcLink, firstAvailableOption.value);
      setAtcState(atcDiv, true);
    } else {
      sizeSelect.value = '';
      setAtcHref(atcLink, null);
      setAtcState(atcDiv, false);
    }
  } else {
    const variantId = radio.dataset.variantId || radio.value;
    setAtcHref(atcLink, variantId);
    setAtcState(atcDiv, radio.dataset.available !== 'false');
    console.log('[upsell-debug] color change -> atc updated directly', { colorHandle, variantId });
  }
}

function handleSizeChangeOptimized(select) {
  const slide = select.closest('.swiper-slide[data-product-id]');
  if (!slide) return;

  const atcLink = slide.querySelector('.atc-upsell-product-a');
  const atcDiv = atcLink && atcLink.firstElementChild;
  const opt = select.selectedOptions[0];
  const isValid = Boolean(select.value) && opt && !opt.disabled;

  setAtcHref(atcLink, isValid ? select.value : null);
  setAtcState(atcDiv, isValid);
}

let upsellOptimizedHandlersBound = false;
function bindUpsellOptimizedHandlersOnce() {
  if (upsellOptimizedHandlersBound) return;
  upsellOptimizedHandlersBound = true;
  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    const label = target.closest('.variant-color-label');
    if (label) {
      console.log('[upsell-debug] click sobre swatch label', { target, label, input: label.querySelector('.variant-color-input-optimized') });
    }
  });

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (!target || typeof target.matches !== 'function') return;
    if (target.matches('.variant-color-input-optimized')) {
      console.log('[upsell-debug] change event en radio de color', { target, checked: target.checked });
      handleColorChangeOptimized(target);
    } else if (target.matches('.variant-size-select')) {
      console.log('[upsell-debug] change event en select de talla', { target, value: target.value });
      handleSizeChangeOptimized(target);
    }
  });
}

function isUpsellVisible() {
  const el = document.querySelector('#cart-drawer--upsell-ab');
  return Boolean(el) && window.getComputedStyle(el).display !== 'none';
}

let activeSwiper = null;
let activeSwiperContainer = null;

function destroyActiveSwiper() {
  if (activeSwiper && typeof activeSwiper.destroy === 'function') {
    try {
      activeSwiper.destroy(true, true);
    } catch (e) {
    }
  }
  activeSwiper = null;
}

function initUpsell() {
  const container = document.querySelector('.upsell-content-optimized');
  if (!container) return;

  if (container === activeSwiperContainer) return;

  destroyActiveSwiper();
  activeSwiper = upsellSwiperOptimized();
  activeSwiperContainer = container;
}

const observeDOMChanges = (element) => {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.previousSibling?.className === "cart-drawer") {
        observer.disconnect();
        initUpsell();
        connectObserver();
      }
    }
  });
  const config = { attributes: true, childList: true, subtree: false };
  observer.observe(element, config);
};

function connectObserver() {
  const targetElement = document.querySelector('#shopify-section-cart-drawer');
  const targetElementB = document.querySelector('#shopify-section-cart-drawer-b');
  const targetElementC = document.querySelector('#shopify-section-cart-drawer-c');
  if (targetElement) {
    observeDOMChanges(targetElement);
  }
  if (targetElementB) {
    observeDOMChanges(targetElementB);
  }
  if (targetElementC) {
    observeDOMChanges(targetElementC);
  }
}

function refreshUpsellVariant() {
  if (!isUpsellVisible()) return;
  initUpsell();
}

bindUpsellOptimizedHandlersOnce();
document.addEventListener('growthbookdata', refreshUpsellVariant);

function runCartDrawerUpsell() {
  if (!isUpsellVisible()) return;
  initUpsell();
  connectObserver();
}

export default runCartDrawerUpsell;
